import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorLinkResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorLink: metadata.getAuthorLink() } as StreamData)

export default authorLinkResolver
